// The app-owned "PENDING" hold marker on `invoices.notes`.
//
// TWO writers apply payment holds and both must produce identical note text, or
// `payment_status='on_hold'` means different things depending on who set it:
//   1. the UI — InvoiceDao.updatePaymentStatusWithNotes (one invoice at a time);
//   2. the sweep — InvoicePaymentService.enforceInvoiceHolds, whose bulk status
//      write cannot edit per-row text, so it calls InvoiceDao.syncHoldMarkers.
//
// Before this was shared, only (1) wrote the marker: 519 prod invoices sat
// on_hold with ZERO of them marked locally, so an automatically-applied hold
// never reached Fakturownia at all.
//
// Removal on the Fakturownia SIDE is a different rule and lives in
// fakturownia/internalNote.ts — there the keyword is stripped wherever it
// appears, because an operator may have typed it into FA by hand. Here we own
// the local note we wrote ourselves, so the prefix form is exact.

/** Add the marker, preserving any operator note behind it. Idempotent. */
export function withPendingMarker(notes: string | null): string {
  if (!notes) return 'PENDING';
  return notes.startsWith('PENDING') ? notes : `PENDING ${notes}`;
}

/** Remove the marker, returning the operator's own text (or null if that was
 *  all there was). Idempotent. */
export function withoutPendingMarker(notes: string | null): string | null {
  if (!notes) return null;
  const stripped = notes.replace(/^PENDING ?/, '').trim();
  return stripped || null;
}
